'use strict';
angular.module('schoolLinqApp').factory('siteService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/site';

		function getSite(id) {
			return $http.get(endpoint, { params: { id: id } });
		}

		function getSites() {
			return $http.get(endpoint + '/list');
		}

		function getSitesForCustomer(customerId) {
			return $http.get(endpoint + '/getSitesForCustomer', {
				params: { customerId: customerId },
			});
		}

		return {
			getSite: getSite,
			getSites: getSites,
			getSitesForCustomer: getSitesForCustomer,
		};
	},
]);
